document.addEventListener("DOMContentLoaded", function () {
  function injectStyles() {
    // const pollInterval = 100; // Poll every 100ms
    // const maxAttempts = 50; // Timeout after 50 attempts (5 seconds)
    // let attempt = 0;

    // const pollForIframe = setInterval(() => {
    //   var looxCarouselFrame = document.querySelector("#looxCarouselFrame");
    //   if (looxCarouselFrame && looxCarouselFrame.contentDocument) {
    //     clearInterval(pollForIframe); // Stop polling
    //     var iframeDocument = looxCarouselFrame.contentDocument;
    //     var cssLink = iframeDocument.createElement("link");
    //     cssLink.href = "theme-reviews.css";
    //     cssLink.rel = "stylesheet";
    //     cssLink.type = "text/css";
    //     iframeDocument.head.appendChild(cssLink);
    //     console.log("Styles injected into loox iframe");
    //   } else {
    //     attempt++;
    //     if (attempt >= maxAttempts) {
    //       clearInterval(pollForIframe); // Stop polling after timeout
    //       console.error(
    //         "Unable to locate or access loox iframe content within timeout"
    //       );
    //     }
    //   }
    // }, pollInterval);
  }

  function handleLooxLoaded() {
    injectStyles();
    // Find the element with href="#looxReviews"
    var reviewLink = document.querySelector('a[href="#looxReviews"]');
    if (!reviewLink) return;

    var looxRatingContent = reviewLink.querySelector(
      ".loox-rating .loox-rating-content"
    );

    var scrollContent = (e) => {
      var scrollEl = document.querySelector('[data-section-type="product"]');
      if (scrollEl) {
        const rect = scrollEl.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.pageYOffset + 150,
          behavior: "smooth", // Smooth scroll
        });
      }
    };

    if (reviewLink) {
      reviewLink.onclick = (e) => {
        e.stopPropagation(); // Prevent this click from bubbling up
        e.preventDefault();
        scrollContent(e);
      };
    }

    if (looxRatingContent) {
      looxRatingContent.addEventListener("click", (e) => {
        scrollContent(e);
      });
    }

    // Check if the URL hash is "#looxReviews"
    if (window.location.hash === "#looxReviews") {
      // Check if the element exists
      if (reviewLink) {
        // Check if the child element exists
        if (looxRatingContent) {
          // Simulate a click on the child element
          looxRatingContent.click();
        }
      }
    }
  }

  // Ensure Loox is loaded before binding the domReady event
  if (typeof LOOX !== "undefined" && LOOX.domReady) {
    LOOX.domReady(handleLooxLoaded);
  } else {
    // Poll for LOOX to be defined if it isn't immediately available
    var looxInterval = setInterval(function () {
      if (typeof LOOX !== "undefined" && LOOX.domReady) {
        clearInterval(looxInterval);
        LOOX.domReady(handleLooxLoaded);
      }
    }, 100);
  }
});
